


import React from "react";
import ToknMusic from './images/ToknMusic.jpg';
import Suggaa from './images/Suggaa.jpg';

const Navbar4 = () => {
  return (
    <div className="bg-gradient-to-r from-blue-900 via-blue-700 to-blue-500 -auto-h-screen">
      <section className="py-8 px-4 dark:bg-blue-800" id="work-experience">

        <h2 className="text-3xl font-bold text-blue-200 dark:text-white mb-4">
          Professional Experiences :-
        </h2>

        <ul className="space-y-4 -mt-2">
  <li className="bg-blue-300 rounded-lg p-4 hover:bg-blue-400 transition duration-300">
    <a href="https://www.linkedin.com/company/tokn-music/" className="flex flex-col md:flex-row items-center">
      <div className="flex items-center justify-center md:justify-start md:flex-shrink-0 md:mr-4">
        <a href="https://www.linkedin.com/company/tokn-music/">
          <img
            className="rounded-full md:mr-0"
            src={ToknMusic}
            alt="Tokn Music Logo"
          />
        </a>
      </div>
      <div className="flex-grow h5">
        <h3 className="text-2xl  text-blue-900 dark:text-white">
        Role: <b> React Frontend Developer </b>
        </h3>
        <div className="text-xl text-blue-900 dark:text-white">
          Company Name : <b>Tokn Inc</b>
        </div>
        <div className="text-blue-800  dark:text-blue-400 text-sm">
        Job Type : <b>  Full-time (Remote)</b>
        </div>
        <div className="text-blue-900 dark:text-blue-400 text-sm">
          Duration : <b>September 2021 - Present</b>
        </div>
        <div className="text-blue-900 font-bold dark:text-blue-400 text-sm">
          Financial Services, San Francisco, California, United States
        </div>
        <div className="text-blue-900 dark:text-blue-400 text-sm mb-2">
          Address: 1167 Willow Lake Rd, Discovery Bay, California 94505
        </div>
                <ul className="list-disc pl-6 mb-2">
                  <li>
                  Developed and maintained web applications using <b>React JS</b>, ensuring seamless user experiences and responsive designs.
                  </li>
                  <li>
                    Built reusable components and front-end libraries, reducing development time and improving code efficiency.
                  </li>
                  <li>
                  Optimized website performance by implementing best practices, including code minification, image compression, and lazy loading techniques.
                  </li>
                  <li>
                    Collaborated with cross-functional teams, including designers and backend developers, to ensure smooth integration of front-end and back-end functionalities.
                  </li>
                  <li>
                    Successfully delivered the <b>"Tokn Music" Minimum Viable Product (MVP)</b> using React.js, meeting all project requirements and deadlines.
                  </li>
                  <li>
                    Implemented blockchain technology into the web platform, enhancing security and transparency for financial transactions.
                  </li>
                  <li>
                    Documented UI components and design patterns, creating a comprehensive library for future development and maintaining consistent visual styles.
                  </li>
                  <li>
                    Conducted code reviews and provided constructive feedback to team members, fostering a culture of continuous improvement and code quality.
                  </li>
                  <li>
                    Stayed up-to-date with the latest front-end development trends and technologies, actively participating in workshops and conferences to expand knowledge and skills.
                  </li>
                </ul>
              </div>
            </a>
          </li>

          <li className="bg-blue-300 rounded-lg p-4 hover:bg-blue-400 transition duration-300">
            <a href="https://www.linkedin.com/company/suggaa/" className="flex flex-col md:flex-row items-center">
            <div className="flex items-center justify-center md:justify-start md:flex-shrink-0 md:mr-4">
        <a href="https://www.linkedin.com/company/suggaa/">
          <img
            className="rounded-full md:mr-0"
            src={Suggaa}
            alt="Suggaa Logo"
          />
        </a>
      </div>
              <div className="flex-grow h5">
                <h3 className="text-2xl  text-blue-900 dark:text-white">
                   Role: <b>Junior Software Developer</b>
                </h3>
                <h4 className="text-xl text-blue-900 dark:text-white">
                Company Name : <b> Suggaa Ventures Pvt Ltd.</b>
                </h4>
                <div className="text-blue-800  dark:text-blue-400 text-sm">
                  Job Type : <b>Full-time (Hybrid)</b>
                </div>
                <div className="text-blue-900 dark:text-blue-400 text-sm">
                 Duration : <b> January 2021 - June 2021</b>
                </div>
                <div className="text-blue-900 font-bold dark:text-blue-900 text-sm mb-0">
                  Online Cab Aggregator Service, Bangalore, Karnataka, India
                </div>
                <div className="text-blue-900 dark:text-blue-400 text-sm mb-2">
                  Address: 1139, Maruthi Complex RR Nagar, Bengaluru, KA 560098
                </div>
                <ul className="list-disc pl-6 mb-2">
                  <li>Worked on the UI of a mobile app built in <b>React Native & Tailwind CSS.</b></li>
                  <li>Developed responsive UI components that adapt to different screen sizes.</li>
                  <li>Collaborated with UX designers and developers to implement new features and design changes.</li>
                  <li>Conducted code reviews and provided feedback to ensure high-quality code and adherence to best practices.</li>
                </ul>
              </div>
           
            </a>
          </li>

          <li className="bg-blue-300 rounded-lg p-4 hover:bg-blue-400 transition duration-300">
            <a href="https://rkmvcc.rkmshillong.org/" className="flex flex-col md:flex-row items-center">
            <div className="flex items-center justify-center md:justify-start md:flex-shrink-0 md:mr-4">
        <a href="https://rkmvcc.rkmshillong.org/">
          <img
            className="rounded-full md:mr-0"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Emblem-Ramakrishna-Mission-Transparent.png/200px-Emblem-Ramakrishna-Mission-Transparent.png"
            alt="RKMVCC Logo"
          />
        </a>
      </div>
              <div className="flex-grow h5">
                <h3 className="text-2xl text-blue-900 dark:text-white">
                    Role: <b> Web Developer - (Intern)</b>
                </h3>
                <h4 className="text-xl  text-blue-900 dark:text-white">
                 Orangisation : <b> Ramakrishna Mission Vivekananda Cultural Centre, Shillong-1</b>
                </h4>
                <div className="text-blue-800 dark:text-blue-400 text-sm">
                  Job Type : <b>Internship (On-site)</b>
                </div>
                <div className="text-blue-900 dark:text-blue-400 text-sm">
                  Duration : <b>April 2019 - October 2019 </b>
                </div>
                <div className="text-blue-900 font-bold dark:text-blue-400 text-sm mb-0">
                  Organization, Institution and Cultural Centre, Shillong, Meghalaya, India.
                </div>
                <div className="text-blue-900 dark:text-blue-400 text-sm mb-2">
                  Address: Quinton Road, Police Bazar, Shillong, Meghalaya 793001.
                </div>
                <ul className="list-disc pl-6 mb-2">
                  <li>Developed an <b>Online Examination System </b>using <b>PHP & MySQL </b>for the Institution of Ramakrishna Mission Vivekananda Cultural Centre-Shillong, Meghalaya, India.</li>
                  <li>Designed the user interface for the system using front-end technologies such as <b>HTML, CSS, Bootstrap, and JavaScript.</b></li>
                  <li>Created a secure login system for students to register and access the examination server.</li>
                  <li>Implemented features such as saving and checking answers, correction of answers during the examination, and automatic logout.</li>
                  <li>Built an admin panel for adding, deleting, and updating user profiles, along with all necessary admin rights to run the system efficiently.</li>
                  <li>Enabled immediate display of marks after students submitted their papers.</li>
                  <li>Reduced the required labor force and produced more accurate results through this online examination system.</li>
                </ul>
              </div>
            </a>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default Navbar4;
